export const roundCurrency = (value: number): number =>
  Math.round((Number.isFinite(value) ? value : 0) * 100) / 100;

export const sumCurrency = (...values: number[]): number =>
  roundCurrency(values.reduce((sum, value) => sum + value, 0));

export const parsePlanPrice = (price: string | undefined): number =>
  roundCurrency(Number.parseFloat(price?.replace(',', '.') ?? '0'));

export const formatCurrencyBRL = (value: number): string =>
  roundCurrency(value).toFixed(2).replace('.', ',');
